import { CountUp } from 'countup.js';
import { Odometer } from 'odometer_countup';

document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.wp-block-base-counter');

    counters.forEach((counter) => {
        const options = {
            startVal: parseInt(counter.dataset.startVal, 10) || 0,
            duration: parseInt(counter.dataset.duration, 10) || 1,
            useGrouping: counter.dataset.separator !== '',
            separator: counter.dataset.separator || '',
            prefix: counter.dataset.prefix || '',
            suffix: counter.dataset.suffix || '',
            plugin: new Odometer(),
            autoAnimate: true,
        };

        counter.innerHTML = '';

        const countUp = new CountUp(counter, parseInt(counter.dataset.endVal, 10), options);
        if (!countUp.error) {
            countUp.start();
        } else {
            console.error(countUp.error);
        }
    });
});
